import Card from './Card.vue';
import { NAME } from './constants';

export const LogServisniZakazky = {
	name: NAME,
	components: {
		Card,
	},
};
